const days = require('../constants/days')
const getDaysRangeFromToday = require('../dates/get-days-range-from-today')

/**
 * Sort location hours
 * @param {*} hours
 */
const sortLocationHours = hours => {
  const daysRange = getDaysRangeFromToday(true)
  const hoursOrdered = []
  for (let i = 0, len = daysRange.length; i < len; i++) {
    hoursOrdered.push({
      day: days[daysRange[i]],
      hours: hours[days[daysRange[i]]],
    })
  }
  return hoursOrdered
}

module.exports = sortLocationHours
